"use client";

import React, { useEffect, useState } from "react";
import appStyle from "../styles/app.module.css";
import styles from "@/app/blog/app.module.css";
import images from "../constants/images";
export default function AboutUsPageContent() {
  const [activeSection, setActiveSection] = useState("our-mission");
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("h2");
      let current = "our-mission";
      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 100;
        if (window.scrollY >= sectionTop) {
          current = section.id;
        }
      });
      setActiveSection(current);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={appStyle.container}>
      <div className={styles.blogContent}>
        <div className={styles.blogContent}>
          <h1>About Us</h1>

          <h2>MyWeddinglyInvites: Where Love Meets Paper (and Pixels)</h2>
          <p>
            Every grand wedding starts with something small… an invitation card.
            But it is not just any card, but the one that gets your aunt to
            cancel her yoga class, your college gang to book flights and your
            best friend to start crying happy tears.
          </p>
          <p>
            That’s where we come in. MyWeddinglyInvites began with one simple
            mission to help couples design digital marriage invitation cards
            that feel as unique as their love story. Whether you’re after a
            royal wedding invitation design, a quirky digital marriage card or a
            heartfelt married invite card for your grandma’s fridge, we’ve got
            you covered.
          </p>
          <p>
            We believe the wedding invitation isn’t just the start of your big
            day. It’s the first “wow” your guests experience. Simply edit the
            details, download the PDF and share it via WhatsApp or email. Yes,
            it’s that simple!
          </p>

          <h2>Our Mission: Making Invitations Less Stressful, More ‘Wow’</h2>
          <p>
            We help you design wedding invitations online that look like they
            cost a fortune… without actually costing a fortune. From custom
            wedding invitations dripping with elegance to affordable wedding
            invites that still get a “whoa!” reaction, we make sure your first
            impression is flawless.
          </p>
          <h2>Our Vision: No More Boring Wedding Cards</h2>
          <p>
            Gone are the days of flipping through dusty catalogues with five
            options that all look the same. We want a world where couples can
            make wedding cards online in a snap that are as unique as their
            hashtags. Whether it’s a digital wedding invitation card, a printed
            keepsake or a photo wedding invitation that shows off your best
            couple selfie, your options here are endless.
          </p>
          <h2>Why Choose MyWeddinglyInvites?</h2>
          <ul>
            <li>
              <h3>You’re the Artist, We’re the Canvas</h3>
            </li>
            <p>
              Play with hundreds of wedding invitation templates. Add your own
              words, photos and that inside joke only your cousins will get.
            </p>
          </ul>

          <ul>
            <li>
              <h3>Traditional or Insta Reel-Ready</h3>
            </li>
            <p>
              Whether you need a royal marriage card design for the elders or a
              trendy digital marriage invitation for your Insta stories, we
              deliver both.
            </p>
          </ul>

          <ul>
            <li>
              <h3>No Panic, Just Perfect</h3>
            </li>
            <p>
              Last-minute wedding planning? Our online wedding invitation maker
              works faster than your caterer’s “almost ready” promise.
            </p>
          </ul>

          <ul>
            <li>
              <h3>Luxury or Budget-Friendly</h3>
            </li>
            <p>
              From luxury wedding invitations to affordable wedding invites, we
              make sure you never have to choose between style and savings.
            </p>
          </ul>

          <h2>Our Promise: Your Love, Your Style</h2>
          <p>
            At MyWeddinglyInvites, we don’t merely make invitation cards but try
            to create the opening scene of your wedding film. Whether it’s a
            custom wedding invitation, a reception invitation card or a digital
            marriage card, it will make people mark the date, set reminders and
            maybe even buy a new outfit.
          </p>
          <p>
            Your wedding deserves an invitation that’s as special as your love
            story. And we’ll help you create wedding cards online that make your
            guests say, “If the invite is this good, imagine the wedding!”
          </p>
          {/* <h2 id="contact" className={styles.sectionHeading}>
            Contact Us
          </h2>
          <div
            className="flex items-center w-full gap-4 p-4 rounded-md mt-4"
            style={{ backgroundColor: "#FFF8F6", borderRadius: "12px" }}
          >
            <div
              style={{
                backgroundColor: "#FFD9CF",
                padding: "8px",
                borderRadius: "4px",
                display: "flex",
              }}
            >
              <img
                src={images.mail.src}
                alt={images.mail.alt}
                style={{ width: "22px", height: "22px" }}
              />
            </div>
            {/* <div className="flex flex-col py-1">
              <div
                className="font-bold mb-1"
                style={{
                  fontSize: "clamp(1.125rem, 4vw, 1.25rem)",
                  color: "#575757",
                }}
              >
                CONTACT US
              </div>
              <div
                style={{
                  fontSize: "clamp(1rem, 4vw, 1rem)",
                  color: "#575757",
                }}
              >
                Email:{" "}
                <a
                  href="mailto:contact@myweddinglyinvites.com"
                  className="underline text-inherit"
                >
                  contact@myweddinglyinvites.com
                </a>
              </div>
            </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}
